'use strict';

var _breakpoints = require('../global/breakpoints');

var initSlideshowInPage = function initSlideshowInPage() {
  var slideContainers = document.querySelectorAll('[data-slideshow]');

  slideContainers.forEach(function (slideContainer) {
    var imagesCount = slideContainer.querySelectorAll('img').length;
    $(slideContainer).slick({
      slidesToScroll: 1,
      slidesToShow: 1,
      transitionDuration: 1000,
      autoplay: true,
      autoplaySpeed: 2000,
      infinite: true,
      fade: true,
      arrows: imagesCount > 1,
      prevArrow: '<span class="icon-prev prev"></span>',
      nextArrow: '<span class="icon-next next"></span>',
      responsive: []
    });
  });

  var collaboration = document.getElementById('collaboration');

  if (collaboration) {
    var images = collaboration.querySelectorAll('.images > div').length;
    $(collaboration.querySelector('.images')).slick({
      slidesToScroll: 1,
      slidesToShow: 4,
      dots: false,
      arrows: images > 4,
      centerMode: false,
      focusOnSelect: true,
      responsive: [{
        breakpoint: _breakpoints.breakpoints.md,
        settings: {
          slidesToShow: 4
        }
      }],
      prevArrow: '<span class="icon-prev prev"></span>',
      nextArrow: '<span class="icon-next next"></span>'
    });
  }
};

initSlideshowInPage();


//////////////////
// WEBPACK FOOTER
// ./js/slideshow/simple-slideshow.js
// module id = ./js/slideshow/simple-slideshow.js
// module chunks = 0